// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_modal__4TXNT {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
}
.modal_inner__7cgA9 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 10vh;
  width: 100%;
  padding: 0 16px;
  max-width: 500px;
}

.modal_close__7LZ4G {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  bottom: -11%;
}
.modal_overlay__j1SnE {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/modal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,OAAO;EACP,MAAM;EACN,8BAA8B;EAC9B,kCAA0B;UAA1B,0BAA0B;AAC5B","sourcesContent":[".modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin: auto;\n}\n.inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 10vh;\n  width: 100%;\n  padding: 0 16px;\n  max-width: 500px;\n}\n\n.close {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  position: absolute;\n  bottom: -11%;\n}\n.overlay {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  top: 0;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(6px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal_modal__4TXNT`,
	"inner": `modal_inner__7cgA9`,
	"close": `modal_close__7LZ4G`,
	"overlay": `modal_overlay__j1SnE`
};
export default ___CSS_LOADER_EXPORT___;
